import _ from "es-toolkit/compat";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { baiFetch } from "../auth";
import { minifyGraphQLQuery } from "../backendai";
import { Project } from "./projects";

export * from "./folders";
export * from "./images";
export * from "./projects";
export * from "./resources";

export const LocalStorageKey = {
  AuthToken: "Backend_AI_FastTrack.authToken",
  Language: "Backend_AI_FastTrack.preferences.language",
  PipelineSummaryCollapse: "Backend_AI_FastTrack.collapse.pipelineSummary",
  TaskTemplateTray: "Backend_AI_FastTrack.collapse.taskTemplateTray",
};

export const coreServiceVersionAtom = atom(async (get) => {
  const response: {
    version: string;
    manager: string;
  } = await baiFetch("/func/").then((res) => res.json());
  return response;
});

export const serviceVersionAtom = atom(async (get) => {
  const response: {
    name: string;
    version: string;
  } = await baiFetch("/pipeline/health/").then((res) => res.json());
  return response.version;
});

export const authTokenAtom = atomWithStorage<string | null>(
  LocalStorageKey.AuthToken,
  null,
  {
    getItem(key: string, initialValue: string | null): string | null {
      return localStorage.getItem(key) ?? initialValue;
    },
    setItem(key: string, newValue: string | null) {
      localStorage.setItem(key, newValue ?? "");
    },
    removeItem: localStorage.removeItem,
  },
  { getOnInit: true }
);

export type UserRole = "superadmin" | "admin" | "user";

export interface User {
  username: string;
  email: string;
  full_name: string;
  is_active: boolean;
  role: UserRole;
  domain_name: string;
  groups: Project[];
  resource_policy: string;
}

export const userAtom = atom(async (get) => {
  const authToken = get(authTokenAtom);
  if (!authToken) {
    return null;
  }
  try {
    const response = await baiFetch("/func/admin/gql", {
      method: "POST",
      body: JSON.stringify({
        query: minifyGraphQLQuery(`
          query {
            user {
              username
              email
              full_name
              is_active
              role
              domain_name
              groups {
                id
                name
              }
              resource_policy
            }
          }
        `),
      }),
    }).then((res) => res.json());
    return response?.data.user as User;
  } catch (e) {
    return null;
  }
});
